import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm3.99 9.01L8 10v11.99h7.99V10.01zM15 20H9v-8h6v8z"
}), 'SpeakerPhoneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SpeakerPhoneSharp.js
// module id = 6353
// module chunks = 2